<template>
  <div class="list-travel" style="margin-top: 50px">
    <van-nav-bar
      :title="name"
      left-text="返回"
      :right-text="region.RegionName"
      left-arrow
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
	<van-icon name="location" size="23"  />
	<span class="van-nav-bar__text">{{region.RegionName}}</span>
</template>
    </van-nav-bar>
    <div class="container" style="margin-top: 20px; padding-bottom: 60px">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          immediate-check
          offset="10"
        >
          <!-- <van-cell v-for="item in list" :key="item" :title="item"> -->
          <div class="list-group">
            <div class="list-group-item" v-for="item in list">
              <router-link :to="{ name: model, params: { id: item.DicNO } }">
                <van-row>
                  <van-col span="11" class="image">
                    <van-image
                      v-if="item.images.length > 0"
                      radius="5"
                      lazy-load
                      :src="item.images[0]['img_urls']"
                    />
                  </van-col>
                  <van-col span="1"></van-col>
                  <van-col span="12" v-if="model == ''">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">4A级景区</div>
                    <div><span class="tag">山岳峡谷</span></div>
                    <div><span class="price">成人票98元</span></div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Town'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      
                    </div>
                    <div class="list_v">
                      <div class="name">{{ item.DicName }}</div>
                      <div class="grade">{{ item.Area }}</div>
                    </div>
                    <div class="flex_list" v-if="item.MainScenic">
                      <span
                        class="tag tags"
                        v-for="items in item.MainScenic.split('、')"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.NearbyScenic }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Scenic'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div class="flex_list" v-if="item.ScenicType">
                      <span
                        class="tag tags"
                        v-for="items in item.ScenicType.split('、')"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Historical }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Village'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div class="flex_list" v-if="item.MainScenic">
                      <span
                        class="tag tags"
                        v-for="items in item.MainScenic.split('、')"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Honour }}</span>
                    </div>
                  </van-col>
                  <van-col
                    span="12"
                    v-else-if="model == 'Hotel' || model == 'Restaurant'"
                  >
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.Telphone }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MaxLoad }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Food'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Taste }}</div>
                    <div class="flex_list" v-if="item.FoodType">
                      <span
                        class="tag tags"
                        v-for="items in item.FoodType.split('、')"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MarketPrice }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Celebritie'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Positional }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.ByDynasty }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Feats }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'NonHeritage'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Honour }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.JudgeGrade }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Inheritor }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Commoditie'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.QualityFeature }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.FoodType }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MarketPrice }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Argumentation'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div>
                      <span class="tag">{{ item.atype.join(",") }}</span>
                    </div>
                    <div>
                      <span class="price">{{ item.MaxLoad }}</span>
                    </div>
                  </van-col>

                  <van-col span="12" v-else-if="model == 'Seastella'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.atype.join(",") }}</div>
                    <div>
                      <span class="tag">{{ item.Money }}</span>
                    </div>
                    <div>
                      <span class="price">{{ item.Join }}</span>
                    </div>
                  </van-col>
                </van-row>
              </router-link>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <!-- <div
        v-if="total.total > total.per_page"
        style="text-align: center; margin: 20px auto"
        @click="more"
      >
        <van-tag type="" size="large">点击加载更多</van-tag>
      </div> -->
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
import { travelList } from "@/api/travel";
export default {
  data() {
    return {
      total: {},
      list: [],
      name: "",
      model: "",
      page: 1,
      loading: false,
      finished: false,
      refreshing: false,
      flag: true,
      timer: null
    };
  },
  computed: {
    region: {
      get() {
        return this.$store.state.region;
      },
    },
  },
  components: { Footer },
  mounted: function () {},
  created() {
    // this.getList();
  },
  methods: {
    onLoad() {
      this.timer = setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
          this.flag = true
          this.page = 1
        }
        if(this.flag){
          this.getList();
          this.flag = false
        }else{
          this.more()
        }
        this.loading = false;
      }, 300);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getList() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$route.params.page = this.page;
      travelList(this.$route.params).then((res) => {
        this.$toast.clear();
        this.model = this.$route.params.model;
        this.total = res.list;
        this.name = res.name;
        document.title = JSON.parse(localStorage.getItem('regionList')).re_name+'-皖云游-'+ this.name
        if (res.list.data.length == 0) {
          if (this.page != 1) {
            this.$toast("没有了");
             this.finished = true;
             clearTimeout(this.timer)
          } else {
            this.$toast("暂时没有数据");
             this.finished = true;
             clearTimeout(this.timer)
          }
        } else {
          for (let i in res.list.data) {
            this.list.push(res.list.data[i]);
          }
        }
        this.$store.commit("SET_RGION", res.region);
        this.loading = false;
        if (this.list.length >= this.total.total) {
          this.finished = true;
        }
         clearTimeout(this.timer)
      }).catch(err=>{
        this.finished = true;
      })
      
    },
    more() {
        this.page += 1;
        this.getList();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({
        name: "District",
        params: { id: this.region.id, pinyin: this.region.RegionEnName },
      });
    },
  },
};
</script>
<style>
.list-travel .van-nav-bar {
  background-color: rgba(43, 178, 240, 1);
  color: #fff;
}
.list-travel .van-nav-bar__text,
.list-travel .van-nav-bar .van-icon {
  color: #fff;
  font-size: 16px;
}
.list-travel .van-nav-bar__title {
  color: #fff;
  font-size: 18px;
}
.flex_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-height: 46px;
  overflow: hidden; /*超出部分隐藏*/
  align-items: center;
}

.tags {
  width: auto;
  border: 1px solid rgb(234, 85, 23);
  margin-right: 6px;
  margin-bottom: 4px;
  padding: 0 2px;
  display: inline-block;
  box-sizing: border-box;
}
.tags p {
  margin-top: 2px;
}
.ff {
  display: flex;
  align-items: center;
}
</style>
<style scoped>
.identify-span {
  float: right;
  color: #333;
}
.list-travel {
  background-color: #fff;
  /* position: fixed; */
}
.carousel {
  border-radius: 0.5em;
  /*height: 110px;*/
}
.van-tag {
  background-color: #ea5517;
}
.list_v {
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.van-row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.van-col--1 {
  width: 2%;
}
.van-col {
  display: flex;
  flex-direction: column;
}
.carousel-inner > .item > img {
  width: 100%;
  height: 110px;
}

.image {
  padding-right: 0px;
}

@media screen and (min-width: 1201px) {
  .zy-container {
    max-width: 420px;
    margin: auto;
    padding: 0px 0px;
  }

  .container {
    max-width: 420px;
    padding: 0px 0px;
    background-color: #fff;
  }

  .twelve {
    padding: 15px 15px;
    height: 280px;
  }

  .search {
    max-width: 420px;
  }

  .district {
    max-width: 420px;
  }
}

@media screen and (max-width: 750px) {
  .zy-container {
    max-width: 420px;
    margin: auto;
    padding: 0px 0px;
  }

  .container {
    max-width: 420px;
    padding: 0px 0px;
    background-color: #fff;
  }

  .search {
    max-width: 420px;
  }

  .district {
    max-width: 420px;
  }
}

.carousel-caption {
  position: absolute;
  right: 10%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 10px;
  padding-bottom: 20px;
  color: #fff;
  text-align: right;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  font-size: 12px;
}

body {
  background-color: white;
}

.top-bar {
  position: fixed;
  z-index: 10008;
  top: 0;
  left: 0;
  height: 50px;
  padding: 5px 0px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: auto;
  text-align: center;
  background-color: rgba(43, 178, 240, 1);
  color: white;
}

.top-bar-inner {
  width: 100%;
  height: 100%;
  height: 40px;
}

.back {
  padding: 0px 15px;
  text-align: left;
}

.location {
  padding-right: 15px;
  text-align: right;
}

.back,
.location {
  display: block;
  font-size: 16px;
  color: white;
}

.top-bar span {
  display: inline-block;
}

.title {
  padding: 10px 0px;
  margin: 0px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
}

.top-bar div {
  padding: 0px 0px;
  height: 40px;
  line-height: 40px;
}

.top-bar .right {
  padding: 0px 15px;
  line-height: 40px;
}

.tag {
  /* border-radius: 0.2em; */
  /* background-color: rgb(249, 91, 0); */
  font-size: 10px;
  color: rgb(234, 85, 23);
}

.ticket {
  font-size: 10px;
}

.symbol {
  font-size: 10px;
  color: red;
}

.price {
  font-size: 12px;
  color: #555;
  /* padding-left:2px; */
  /* line-height: 5px; */
}
.identify {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: rgb(241, 91, 26);
}

.name {
  /* padding: 2px 0px; */
  font-family: "Microsoft YaHei";
  font-size: 14px;
  font-weight: bold;
  color: black;
}

.grade {
  font-size: 12px;
  color: #777;
}

.list-group-item {
  padding: 5px 0px;
  border-bottom: 5px solid #f7f7f7;
}
</style>